import { defineMessages } from 'react-intl'

const messages = defineMessages({
  home: {
    id: 'Breadcrumbs.home',
    description: 'Texto para la página de home',
    defaultMessage: 'Inicio'
  },
  layer1PageName: {
    id: 'Breadcrumbs.layer1PageName',
    description: 'Texto para las migas de pan del nombre de la capa 1',
    defaultMessage: 'Panel de indicadores de competitividad'
  },
  methodology: {
    id: 'Breadcrumbs.methodology',
    description: 'Texto para las migas de pan de metodología',
    defaultMessage: 'Metodología'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/messages.js